import {
  Card,
  CardContent,
} from 'component_library/Lib_Design_System/base_components/ui/card'
import { cn } from '@/lib/utils'
import { If } from '@/utility_components/ControlStatements'
import useBreakpoint from 'hooks/useBreakPoint'
import { VALUE_PROPS } from './constants'
import SquiggleDivider from './SquiggleDivider'

interface SearchValuePropProps {
  index: number
  showValueProp: boolean
  total: number
}

// Banners appear after the first provider card and then every 3 cards
// (indexes 0, 3, 6…), cycling through VALUE_PROPS stats — but never after
// the last provider, so a banner always sits between two providers (none
// shown when there's only one).
const SearchValueProp: React.FC<SearchValuePropProps> = ({
  index,
  showValueProp,
  total,
}) => {
  const { v2Breakpoints } = useBreakpoint()

  const isLastProvider = index === total - 1

  if (!showValueProp || index % 3 !== 0 || isLastProvider) {
    return null
  }

  const statIndex = Math.floor(index / 3)
  const stat = VALUE_PROPS[statIndex % VALUE_PROPS.length]

  return (
    <Card
      className={cn(
        "~mx-5 ~my-2 ~rounded ~border-0 ~shadow-none ~bg-latte ~bg-[url('/images/Pattern-Leaves.svg')] ~bg-center",
        v2Breakpoints.isMobileScreen ? '~bg-[length:300%]' : '~bg-[length:100%]'
      )}
    >
      <CardContent className="~px-4 ~py-4 ~text-center">
        <div className="~flex ~items-center ~justify-center ~gap-3">
          <SquiggleDivider />
          <p className="~font-gibson ~text-xl ~font-medium ~text-navy">
            {stat.title}
          </p>
          <SquiggleDivider className="~scale-x-[-1]" />
        </div>
        <p className="~font-mrseavesxl ~text-xl ~font-bold ~text-black">
          {stat.description}
          <If condition={stat.footnote}>
            <sup>*</sup>
          </If>
        </p>
      </CardContent>
    </Card>
  )
}

export default SearchValueProp
